import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Table = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Table" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M18 1C20.7614 1 23 3.23858 23 6V18C23 20.7614 20.7614 23 18 23H6C3.23858 23 1 20.7614 1 18V6C1 3.23858 3.23858 1 6 1H18ZM3 18C3 19.6051 4.26055 20.9158 5.8457 20.9961L6 21V18H3ZM8 21H11V18H8V21ZM13 21H18C19.6569 21 21 19.6569 21 18H13V21ZM3 16H6V13H3V16ZM8 16H11V13H8V16ZM13 16H21V13H13V16ZM3 11H6V8H3V11ZM8 11H11V8H8V11ZM13 11H21V8H13V11ZM6 3C4.39489 3 3.08421 4.26055 3.00391 5.8457L3 6H21C21 4.34315 19.6569 3 18 3H6Z" fill="#000" />
  </StyledIcon>
));

Table.displayName = 'Table';

export { Table };
